import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const services = [
    {
        id: 1,
        iconClass: "flaticon-books",
        titleKey: "ServicesContent3_Title18",
        link: "/news-18",
    },
    {
        id: 2,
        iconClass: "flaticon-university",
        titleKey: "ServicesContent3_Title17",
        link: "/news-17",
    },
    {
        id: 3,
        iconClass: "flaticon-open-book",
        titleKey: "ServicesContent3_Title14",
        link: "/news-14",
    },
    {
        id: 4,
        iconClass: "flaticon-mortarboard",
        titleKey: "ServicesContent3_Title15",
        link: "/news-15",
    },
    {
        id: 5,
        iconClass: "flaticon-university",
        titleKey: "ServicesContent3_Title16",
        link: "/news-16",
    },
    {
        id: 6,
        iconClass: "flaticon-exam",
        titleKey: "ServicesContent3_Title13",
        link: "/news-13",
    },
    {
        id: 7,
        iconClass: "flaticon-books",
        titleKey: "ServicesContent3_Title10",
        link: "/news-10",
    },
    {
        id: 8,
        iconClass: "flaticon-diploma",
        titleKey: "ServicesContent3_Title9",
        link: "/news-9",
    },
    {
        id: 9,
        iconClass: "flaticon-earth-globe",
        titleKey: "ServicesContent3_Title8",
        link: "/news-8",
    },
    {
        id: 10,
        iconClass: "flaticon-book",
        titleKey: "ServicesContent3_Title5",
        link: "/news-5",
    },
    {
        id: 11,
        iconClass: "flaticon-blackboard",
        titleKey: "ServicesContent3_Title11",
        link: "/news-11",
    },
    {
        id: 12,
        iconClass: "flaticon-professor",
        titleKey: "ServicesContent3_Title4",
        link: "/news-4",
    },
    {
        id: 13,
        iconClass: "flaticon-school-material",
        titleKey: "ServicesContent3_Title6",
        link: "/news-6",
    },
    {
        id: 14,
        iconClass: "flaticon-library",
        titleKey: "ServicesContent3_Title7",
        link: "/news-7",
    },
    {
        id: 15,
        iconClass: "flaticon-student",
        titleKey: "ServicesContent3_Title0",
        link: "/news-0",
    },
    {
        id: 16,
        iconClass: "flaticon-books-1",
        titleKey: "ServicesContent3_Title1",
        link: "/news-1",
    },
    {
        id: 17,
        iconClass: "flaticon-student-1",
        titleKey: "ServicesContent3_Title2",
        link: "/news-2",
    },
    {
        id: 18,
        iconClass: "flaticon-blackboard-1",
        titleKey: "ServicesContent3_Title3",
        link: "/news-3",
    },
    {
        id: 19,
        iconClass: "flaticon-ink",
        titleKey: "ServicesContent3_Title12",
        link: "/news-12",
    },
];

class ServicesContent3 extends Component {
    state = {
        currentPage: 1,    // 默认选中第一页
        itemsPerPage: 8,
    };

    render() {
        const { t } = this.props;
        const { currentPage, itemsPerPage } = this.state;

        // ------- 分页核心 -------
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = services.slice(indexOfFirstItem, indexOfLastItem);

        const totalPages = Math.ceil(services.length / itemsPerPage);

        return (
            <>
                <div className="row">
                    {currentItems.map(service => (
                        <div key={service.id} className="col-lg-3 col-md-6">
                            <Link to={service.link}>
                                <div className="services-bx text-left m-b30">
                                    <div className="feature-lg text-white m-b30">
                                        <span className="icon-cell">
                                            <i className={service.iconClass}></i>
                                        </span>
                                    </div>
                                    <div className="icon-content">
                                        <h4 className="ttr-tilte">{t(service.titleKey)}</h4>
                                    </div>
                                    <div className="service-no">
                                        {service.id.toString().padStart(2, "0")}
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>

                {/* -------- 分页按钮 -------- */}
                <div className="pagination-wrapper text-center m-t30">

                    {[...Array(totalPages)].map((_, index) => {
                        const page = index + 1;

                        return (
                            <button
                                key={page}
                                onClick={() => this.setState({ currentPage: page })}
                                className={`btn m-1 ${
                                    page === currentPage
                                        ? "pagination-active"
                                        : "pagination-inactive"
                                }`}
                            >
                                {page}
                            </button>
                        );
                    })}

                </div>
            </>
        );
    }
}

export default withTranslation()(ServicesContent3);
